<template>
  <div class="user_coupons">
    <UserHead/>
    <UserNavi/>
    <div class="user_coupons_main">
      <el-tabs v-model="tab" :stretch="true">
        <el-tab-pane label="已购功能" name="access">
          <div class="user_coupons_container">
            <div class="user_coupons_box" v-infinite-scroll="getAccessOrder">
              <div class="coupons_one" v-for="(item,index) in acoupons" :key="index">
                <div class="coupons_title">
                  {{item.goods_title}}
                </div>
                <div class="coupons_price" v-if="item.isgift === 1">
                  赠送
                </div>
                <div class="coupons_price" v-if="item.isgift !== 1">
                  实付: ￥{{item.price/100}}
                </div>
                <div class="coupons_content">
                  <div class="coupons_three_left">
                    数量: {{item.counts}}
                  </div>
                  <div class="coupons_three_right">
                    原价: ￥{{item.oprice}}
                  </div>
                </div>
                <div class="coupons_time">
                  购买时间: {{item.ctime_str}}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已购VIP" name="role">
          <div class="user_coupons_container">
            <div class="user_coupons_box" v-infinite-scroll="getRoleOrder">
              <div class="coupons_one" v-for="(item,index) in coupons" :key="index">
                <div class="coupons_title">
                  {{item.goods_title}}
                </div>
                <div class="coupons_price">
                  ￥{{item.price}}
                </div>
                <div class="coupons_content">
                  {{item.pre_role_name}} ➠ {{item.to_role_name}}
                </div>
                <div class="coupons_time">
                  起 {{item.ctime_str}} ➠ 止 {{item.exptime_str}}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import { getRoleOrderLog,getAccessOrderLog } from '../../api/api'
  import { getJsonStorage } from "../../util/storage";
  import UserHead from './head'
  import UserNavi from './navi'

  export default {
    name: "UserCoupons",
    components:{
      UserHead,
      UserNavi
    },
    data() {
      return {
        browserType: this.$browserType,
        user: getJsonStorage('openai_user'),
        tab:'access',
        page: 1,
        size: 10,
        pages: 1,
        apage: 1,
        asize: 10,
        apages: 1,
        coupons: [],
        acoupons: [],
        loading:false,
        aloading:false
      }
    },
    mounted(){
      this.getRoleOrder();
      this.getAccessOrder();
    },
    methods: {
      getRoleOrder(){
        if(!this.loading){
          this.loading = true;
          getRoleOrderLog(this.page,this.size).then(res => {
            if(res && res.status === 0 && res.data && res.data.length > 0){
              for(let r in res.data){
                res.data[r]['ctime_str'] = new Date(res.data[r]['ctime']*1000).toLocaleString();
                res.data[r]['exptime_str'] = new Date(res.data[r]['exptime']*1000).toLocaleString();
                this.coupons.push(res.data[r]);
              }
              this.loading = false;
            }
            this.page++;
          })
        }
      },
      getAccessOrder(){
        if(!this.aloading){
          this.aloading = true;
          getAccessOrderLog(this.apage,this.asize).then(res => {
            if(res && res.status === 0 && res.data && res.data.length > 0){
              for(let r in res.data){
                res.data[r]['ctime_str'] = new Date(res.data[r]['ctime']*1000).toLocaleString();
                this.acoupons.push(res.data[r]);
              }
              this.aloading = false;
            }
            this.apage++;
          })
        }
      }
    }
  }
</script>

<style scoped>
  .user_coupons {
    position: absolute;
    top:6vh;
    left:0;
    height:94vh;
    width:100%;
    margin:0;
  }
  .user_coupons_container {
    width:90%;
    margin:0 5%;
    height:66vh;
    overflow-y: scroll;
  }
  .user_coupons_main {
    width:94%;
    margin:1vh auto;
    border:1px solid #ccc;
    border-radius: 1rem;
  }
  .coupons_one {
    float:left;
    text-align:left;
    height:5.4rem;
    width:95%;
    border-bottom:1px solid rgba(100,100,100,0.2);
  }

  .coupons_title {
    color:#0295c3;
    width:70%;
    float:left;
    height:2rem;
    font-size:1rem;
    line-height: 2rem;
  }

  .coupons_price {
    color:#ce0000;
    width:30%;
    height:2rem;
    float:left;
    font-size:.9rem;
    line-height:2rem;
    text-align: right;
  }

  .coupons_content {
    color:#0295c3;
    width:100%;
    float:left;
    height:1.6rem;
    font-size: .8rem;
    line-height: 1.6rem;
  }

  .coupons_time {
    color:#ce0000;
    width:100%;
    float:left;
    height:1.6rem;
    font-size: .8rem;
    line-height: 1.6rem;
  }

  .coupons_three_left {
    width:30%;
    float:left;
    text-align: left;
  }

  .coupons_three_right {
    width:30%;
    float:right;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/coupons.vue